import { z } from 'zod';

import { isPercent } from './tax-rate-rules';

export const taxRateFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, { error: 'tax:validation.nameRequired' })
    .max(120, { error: 'tax:validation.nameLength' }),
  countryCode: z.string().regex(/^[A-Z]{2}$/, { error: 'tax:validation.countryRequired' }),
  region: z.string().trim().max(20, { error: 'tax:validation.regionLength' }),
  postalPattern: z.string().trim().max(40, { error: 'tax:validation.postalLength' }),
  ratePercent: z
    .string()
    .trim()
    .min(1, { error: 'tax:validation.rateRequired' })
    .refine(isPercent, { error: 'tax:validation.rateRange' }),
  appliesToShipping: z.boolean(),
  priority: z.coerce
    .number<string | number>()
    .int({ error: 'tax:validation.priority' })
    .min(0, { error: 'tax:validation.priority' }),
  isActive: z.boolean(),
});

export type TaxRateFormInput = z.input<typeof taxRateFormSchema>;
export type TaxRateFormOutput = z.output<typeof taxRateFormSchema>;

export const taxSettingsSchema = z.object({
  provider: z.enum(['none', 'manual']),
  pricesIncludeTax: z.boolean(),
});

export type TaxSettingsForm = z.infer<typeof taxSettingsSchema>;
